module.exports = __webpack_public_path__ + "static/media/header_image_07.e07ea649.jpg";